export function getErrorMessage(error: unknown): string {
    if (error && typeof error === 'object' && 'graphQLErrors' in error) {
        const { graphQLErrors } = error as {
            graphQLErrors?: Array<{ message?: string }>;
        };
        const graphQLMessage = graphQLErrors?.[0]?.message?.trim();
        if (graphQLMessage) {
            return graphQLMessage;
        }
    }
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'An unexpected error occurred';
}
